import { BuildingWithConvertedAddresses, POI } from '../../utils/types';

export const fetchPOIsForBuilding = async (
    building: BuildingWithConvertedAddresses,
    lngLat: { lat: number; lng: number },
): Promise<BuildingWithConvertedAddresses> => {
    // Now perform reverse geocoding
    const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

    // Now fetch POIs using the Tilequery API
    const tilesetId = 'mapbox.mapbox-streets-v8';
    const radius = 500; // in meters
    const layers =
        'poi_label,airport_label,transit_stop_label,ferry_aerialway_label,golf_hole_label,path_pedestrian_label,admin_0_boundary_disputed,admin_0_boundary,admin_1_boundary,admin_0_boundary_bg,aerialway,bridge_rail_tracks,bridge_rail,bridge_pedestrian,bridge_steps,bridge_path,bridge_pedestrian_case,bridge_steps_bg,bridge_path_bg,road_rail_tracks,road_rail,ferry_auto,ferry,golf_hole_line,road_pedestrian,road_steps,road_path,road_pedestrian_case,road_steps,road_path_bg'; // Layer containing POIs
    const limit = 15;

    return fetch(
        `https://api.mapbox.com/v4/${tilesetId}/tilequery/${lngLat.lng},${lngLat.lat}.json?radius=${radius}&layers=${layers}&limit=${limit}&access_token=${accessToken}`,
    )
        .then((response) => response.json())
        .then((tilequeryData) => {
            const pois: POI[] = tilequeryData.features.map((feature: any) => {
                const properties = feature.properties;
                return {
                    id: feature.id.toString(),
                    type: feature.type,
                    properties: {
                        name: properties.name || properties.ref || 'Unknown',
                        category: properties.class || properties.type || 'Unknown',
                        layer: properties.tilequery.layer,
                        distanceInMeters: properties.tilequery.distance,
                    },
                    geometry: feature.geometry,
                };
            });

            // Add POIs to the building object
            building.pois = pois;

            return building;
        })
        .catch((error) => {
            console.error('Error fetching POIs:', error);
            return building;
        });
};
